export function scEditFlag(scStatus: string): boolean {
  if(!scStatus) return false;
  const scEditStatuses = [ 'Draft', 'Revised Draft', 'Submitted Draft', 'Pending Revision', 'Open', 'Quotation Expired'];
  const scViewStatuses = [  'QT Successful', 'QT Failed', 'Under Production', 'Contract Expired', 'SC Cancelled', 'SC Completed' ];
  if(scEditStatuses.includes(scStatus)) return true;
  if(scViewStatuses.includes(scStatus)) return false;
  // eslint-disable-next-line
  console.error('Unsupported SC status encountered');
  return false;
}